export * from "./IUIMessage";
//# sourceMappingURL=index.js.map